<script setup>
import { GA } from '@/mixins/Ga';

defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const hostname = (url) => new URL(url).hostname;
const ga = new GA({ category: 'midBody', action: 'clicExterne' });
</script>

<template>
    <div
        v-if="data && data[0] && data[0].url"
        class="PartnerLink Page__right is-s border-dark-blue print:border-light-gray mt-4 border-t-2 pt-6 print:hidden md:mt-10 md:pt-8"
    >
        <a
            :href="data[0].url"
            target="_blank"
            v-on:click="ga.send({ label: data[0].url, camelCase: false })"
        >
            <Btn
                class="text-dark-blue print:saturate-0"
                color="currentColor"
                :up="true"
                :text="hostname(data[0].url)"
            />
        </a>
    </div>
</template>
